import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './InstagramLoader.module.css';
import { Instagram } from 'react-content-loader';

const InstagramLoader = ({ isSpinner = false, count = 12 }) => {
  return (
    <div className={classNames(css.productLoaders, { [css.spinnerLoaders]: isSpinner })}>
      {[...Array(count)].map((_, i) => (
        <Instagram key={i} />
      ))}
    </div>
  );
};

InstagramLoader.propTypes = {
  isSpinner: PropTypes.bool,
  count: PropTypes.number,
};

export default InstagramLoader;
